import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installGlobalHandlers } from "./report";
import { initLocale } from "./i18n";
import "./styles.css";

// Before the first render: the landing and changelog pages never reach the
// Discord handshake, so they would otherwise be stuck on the default.
initLocale(null);
installGlobalHandlers();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary trace={null}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
